(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* Micush: on hover, fill the Joy Wishlist heart with its own (app-configured) outline colour */
  (() => {
    const SEL = 'joy-wishlist-button';
    const paint = (host, on) => {
      const p = host.shadowRoot && host.shadowRoot.querySelector('svg path');
      if (!p) return;
      if (on) {
        const stroke = getComputedStyle(p).stroke;
        if (!stroke || stroke === 'none') return;
        if (p.dataset.micushFill === undefined) p.dataset.micushFill = p.style.fill || '-';
        p.style.transition = 'fill 0.2s ease';
        p.style.fill = stroke;
      } else if (p.dataset.micushFill !== undefined) {
        const orig = p.dataset.micushFill;
        p.style.fill = orig === '-' ? '' : orig;
        delete p.dataset.micushFill;
      }
    };
    document.addEventListener('mouseover', (e) => {
      const host = e.target.closest && e.target.closest(SEL);
      if (host) paint(host, true);
    });
    document.addEventListener('mouseout', (e) => {
      const host = e.target.closest && e.target.closest(SEL);
      if (host && !host.contains(e.relatedTarget)) paint(host, false);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
